export const mountQueryURL = (params: {}) => {
  const esc = encodeURIComponent;
  const query = Object.keys(params)
    .map(k => esc(k) + '=' + (params[k] ? esc(params[k]) : ''))
    .join('&');
  return '?' + query
}